<div class="show-map-button">
    <ui-map-button>
        <ui-icon
            aria-hidden
            [icon]="'mobile-mode-map'"
        />
    </ui-map-button>
</div>
